{
  "greeting": "Ciao! Come posso aiutarti con il vino oggi?",
  "thinking": "✨ Sto pensando...",
  "thinkingStep": "✨ Stappando l'abbinamento perfetto per te…🍷",
  "askAboutWine": "Es. Bordeaux rosso anni '90 circa $1500 | Borgogna bianco village sotto $600",
  "askAboutWineFirst": "Voglio comprare (regione + colore + annata + budget)",
  "waitingForResponse": "In attesa di risposta...",
  "dailyLimitReached": "Hai raggiunto il limite giornaliero di consulenze. Torna dopo le 00:00 HKT per continuare.",
  "chatHistory": "La tua cronologia chat",
  "noChatHistory": "Nessuna cronologia chat",
  "startConversation": "Inizia una conversazione per vederla qui",
  "backToChat": "Torna alla chat",
  "newChat": "Nuova chat",
  "history": "Cronologia",
  "search": "Cerca",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Consulente vinicolo",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} vino consigliato",
  "winesRecommended": "{count} vini consigliati",
  "justNow": "Proprio ora",
  "minuteAgo": "{count} minuto fa",
  "minutesAgo": "{count} minuti fa",
  "hourAgo": "{count} ora fa",
  "hoursAgo": "{count} ore fa",
  "dayAgo": "{count} giorno fa",
  "daysAgo": "{count} giorni fa",
  "noMessagesYet": "Nessun messaggio ancora",
  "perBottle": "Per bottiglia",
  "priceNA": "Prezzo non disponibile",
  "buyNow": "Acquista ora",
  "moreInformation": "Maggiori informazioni",
  "share": {
    "button": "Condividi",
    "title": "Condividi conversazione",
    "description": "Condividi questa conversazione con i tuoi amici usando il link qui sotto:",
    "generating": "Generazione link di condivisione...",
    "error": "Impossibile generare il link di condivisione",
    "copy": "Copia",
    "copied": "Copiato!",
    "note": "Nota: Questo link scadrà tra 30 giorni. Quando qualcuno aprirà questo link, vedrà una copia di questa conversazione."
  },
  "checkOutWine": "Dai un'occhiata a questo vino: {name} {vintage}",
  "linkCopied": "Link copiato negli appunti!",
  "contactWhatsApp": "Contattaci su WhatsApp per più opzioni",
  "errorLoadingWine": "Mi dispiace, non sono riuscito a caricare i dettagli del vino.",
  "errorOccurred": "Si è verificato un errore durante il recupero della risposta.",
  "you": "Tu",
  "welcome": {
    "intro": "Benvenuto su WWX, sono Zyra, la tua consulente vinicola IA. Puoi accedere a:",
    "features": {
      "globalMarket": "Mercato globale dei vini pregiati (venditori UK, FR, HK)",
      "realTimeOffers": "Migliori offerte in tempo reale nel tuo budget",
      "personalized": "Raccomandazioni personalizzate solo per te",
      "comparison": "Confronto facile tra annate e marchi",
      "instantCheckout": "Quantità e spedizione istantanee"
    },
    "question": "Cosa posso consigliarti oggi?",
    "trendingPrompts": "Esempi di richieste",
    "promptExamples": {
      "title": "Come chiedere:",
      "good": "✓ Buoni esempi:",
      "bad": "✗ Evita richieste senza budget:"
    },
    "prompts": {
      "bordeaux": "Bordeaux rosso circa $800",
      "champagne": "Champagne di vigneron sotto $2000",
      "firstGrowth": "Miglior offerta first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "È stato utile",
    "notHelpful": "Non è stato utile",
    "thankYou": "Grazie per il tuo feedback!",
    "whatDidYouLike": "Cosa ti è piaciuto?",
    "whatCouldBeImproved": "Cosa potrebbe essere migliorato?",
    "category": "Categoria",
    "selectCategory": "Seleziona una categoria",
    "categories": {
      "accuracy": "Precisione",
      "helpfulness": "Utilità",
      "responseSpeed": "Velocità di risposta",
      "clarity": "Chiarezza",
      "other": "Altro"
    },
    "comments": "Commenti",
    "placeholder": "Raccontaci di più sulla tua esperienza...",
    "cancel": "Annulla",
    "submit": "Invia feedback",
    "submitting": "Invio in corso..."
  },
  "auth": {
    "limitReached": "Limite giornaliero raggiunto",
    "signUpToday": "Registrati per più messaggi",
    "limitMessage": "Hai raggiunto il limite giornaliero di messaggi. Registrati per un account gratuito per continuare la chat.",
    "benefitsMessage": "Crea un account gratuito per continuare a chattare e salvare la cronologia chat su tutti i dispositivi.",
    "remainingMessages": "Hai ancora {count} messaggi disponibili oggi",
    "signUp": "Registrati",
    "login": "Accedi",
    "loggedInAs": "Connesso come {email}",
    "logout": "Esci"
  }
}
